import React, { useRef, useState } from 'react';
import './NumberInput.css';
import PropTypes from 'prop-types';
import { getNumberInputParameters } from 'modules/questionnaire/helpers';
import { useNumberInputValidation } from 'modules/questionnaire/useNumberInputValidation';
import Button from 'new-ui/Components/Button';
import { useTranslation } from 'utils/modifiedTranslation';
import { QuestionTitle } from '../../QuestionTitle';

const NumberInput = (props) => {
  const {
    q,
    user,
    onselect,
    initValue,
    showTitle = false,
  } = props;
  const [value, setValue] = useState(q.getQuestionValue ? q.getQuestionValue(user) : (initValue || ''));
  const { t } = useTranslation();
  const $input = useRef(null);
  const {
    step, unit, max, min,
  } = getNumberInputParameters(q.numberType);

  const validate = useNumberInputValidation({ max, min });

  const handleChange = (event) => {
    const { target: { value: nextValue } } = event;
    if (validate(nextValue).isValid) {
      setValue(nextValue);
    }
  };

  return (
    <div className="number-input-question">
      { (showTitle || q?.showTitle) ? <QuestionTitle q={q} /> : null}
      <div className="number-input-question-input">
        <input
          step={step}
          min={min}
          max={max}
          type="number"
          ref={$input}
          value={value}
          onChange={handleChange}
        />
        {' '}
        <span>{unit}</span>
      </div>
      {
        q.instruction ? (
          <div className="number-input-instructions">{t(q.instruction)}</div>
        ) : null
      }
      <Button
        title={t('general.next')}
        action={() => {
          onselect(value);
        }}
      />
    </div>
  );
};

NumberInput.propTypes = {
  q: PropTypes.shape({
    numberType: PropTypes.string.isRequired,
    getQuestionValue: PropTypes.func,
    instruction: PropTypes.string,
    showTitle: PropTypes.bool,
  }).isRequired,
  user: PropTypes.object,
  initValue: PropTypes.any,
  onselect: PropTypes.func.isRequired,
  showTitle: PropTypes.bool,
};

export default NumberInput;
